import {
  REQUEST_CHART_SENSORS,
  RESPONSE_CHART_SENSORS,
  REQUEST_CHART_SENSORS_FAILURE,
  CLEAR_CHART_SENSORS,
} from "../actions/chartSensorsActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  data: null,
  errors: [],
};

const chartSensorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CHART_SENSORS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    case RESPONSE_CHART_SENSORS:
      return Object.assign({}, state, {
        dataState: states.READY,
        data: action.data,
      });
    case REQUEST_CHART_SENSORS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    case CLEAR_CHART_SENSORS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default chartSensorsReducer;
